import murmurhash from 'murmurhash-js';
import db from '../dexie-db/db';
import SyncBoxState from './SyncBoxState';
export function generateSyncBoxId(config) {
    return String(murmurhash.murmur3(JSON.stringify({
        filters: config.pullConfig.filters,
        collectionName: config.collectionName,
        remoteCollectionName: config.remoteCollectionName,
    }), 0));
}
export async function getSyncBoxIdFromNodeId(tableName, nodeId) {
    const node = await db.table(tableName).get(nodeId);
    return node?._syncBoxId;
}
export async function getSyncBoxStateFromNodeId(tableName, nodeId) {
    const syncBoxId = await getSyncBoxIdFromNodeId(tableName, nodeId);
    if (!syncBoxId)
        return null;
    return new SyncBoxState(syncBoxId);
}
